// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"e507ab87e9016b36","4999":"794f62fea3789408","5198":"87cde24818493ef1","8040":"4ecf317cf4f9a6ed","8270":"87cde24818493ef1"}[chunkId] + ".css";
};